import { AppState } from "@store";
import { AdUnitInfo } from "@common";
import { adUnitParamsSelector } from "./adUnitAssetSelector";
import { FetchingState } from "rd-redux-http";

export function existingAdUnitListSelector(appState: AppState): AdUnitInfo[] {
    const adUnitParams = adUnitParamsSelector(appState);
    const adUnitList = FetchingState.getDataOrDefault(appState.adUnitBuilder.adUnitList, []);

    if (!adUnitParams) {
        return [];
    }

    return adUnitList.filter(u => u.adType === adUnitParams.adType && u.adFormatSize === adUnitParams.adFormat);
}
